module.exports = __webpack_public_path__ + "img/Labrynth2.c1c65a5d.png";